import React from 'react'
import _ from 'lodash'

import { withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableHead from '@material-ui/core/TableHead'
import TableBody from '@material-ui/core/TableBody'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'

import { renderDatasheetInputs } from '../Inputs'

const styles = {
    form: {
        margin: '20px'
    },
    thead : {
        '& tr th' : {
            color: '#019EAC',
            fontSize: '0.95rem',
            fontWeight: 600,
            borderBottom : 'none',
            backgroundColor : '#EFEEEF',
        }
    },
    tbody : {
        '& tr td' : {
            color : '#676767',
            fontSize: '0.95rem',
        },
        '& tr td:first-child' : {
            fontWeight: 500,
        }
    }
}


const DatasheetForm = (props) => {
    const { classes, schema, permissions, initialValues } = props

    const certification = !!schema.properties["ESTADO_CERTIFICACION"]

    const disableDatasheetFields = permissions.role === "externo"
    const disableValidatedDatasheetFields = certification && permissions.role === "coordinado"
    const disableCertificationFields = permissions.role === "coordinado"
    const disableDocumentUploadFields = permissions.role === "externo"

    let estadoCertificacion = {}
    if (certification && !!initialValues){
        estadoCertificacion = _.get(initialValues, 'datasheet.ESTADO_CERTIFICACION')
    }

    return (
        <Table className={classes.table}>
            <TableHead className={classes.thead}>
                <TableRow>
                    <TableCell align="center">Dato Técnico</TableCell>
                    <TableCell align="center">Valor</TableCell>
                    {certification && <TableCell align="center">Estado Certificación</TableCell>}
                </TableRow>
            </TableHead>
            <TableBody className={classes.tbody}>
                {renderDatasheetInputs(
                    schema,
                    estadoCertificacion,
                    disableDatasheetFields,
                    disableValidatedDatasheetFields,
                    disableCertificationFields,
                    disableDocumentUploadFields
                )}
            </TableBody>
        </Table>
    )
}

export default withStyles(styles)(DatasheetForm)